import { useCallback, useEffect, useState } from 'react'
import { GetImages } from '../../../../utils/GetImages'
import SeparaterLine from '../../../common/SeparaterLine'
import { Offcanvas } from 'react-bootstrap'
import { UserLoginData } from '../../../common/charts/Enums'
import BasicDetailsForm from './BasicDetailsForm'
import { DocumentEntityTypesEnum, DocumentService, DocumentTypesEnum, OrganizationService, PropertyItemVM } from '@propertelligent/client-api'
import apiHelper from '../../../../utils/apiHelper'
import { FORM_CONTROLFIELD_TYPES } from '../../../../constants/constants'
import { validateEmail, validateName, validateNumber, validateZipCode } from '../../../../utils/validateHelper'
import { useError } from '../../../../utils/context/ErrorContext'

const BasicDetailsCard = ({ basicDetailsData = undefined, setBasicDetailsData = (x) => { return } }) => {
  const { errors, errorMessages, setErrors, setErrorMessages, clearErrors } = useError();
  const [data, setData] = useState<any>({})
  // const [orgImage, setOrgImage] = useState<any>()
  const [values, setValues] = useState({
    organizationName: "",
    email: "",
    phoneNumber: "",
    website: "",
    streetAddress: "",
    unitNumber: "",
    city: "",
    state: "",
    zip: ""
  });
  const [mainImage, setMainImage] = useState<any>();
  const [fileName, setFileName] = useState("");
  const [propertyValue, setPropertyvalue] = useState<PropertyItemVM>();
  const [showModal, setShowModal] = useState(false)
  const organizationId = Number(sessionStorage.getItem(UserLoginData.organization_id));
  const [documentId, setDocumentId] = useState()

  const websiteRegex = /^(https?:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(\/.*)?$/;

  useEffect(() => {
    getUserData();
  }, [documentId]);

  const getUserData = useCallback(() => {
    apiHelper(OrganizationService.getApiOrganization1, { showNotification: false }, organizationId)
      .then((res) => {
        setBasicDetailsData(false)
        setData(res?.data?.success)
        setValues({
          ...values,
          organizationName: res?.data?.success?.name,
          email: res?.data?.success?.email,
          phoneNumber: res?.data?.success?.phoneNumber,
          website: res?.data?.success?.website,
          streetAddress: res?.data?.success?.address?.streetAddress,
          unitNumber: res?.data?.success?.unitNumber,
          city: res?.data?.success?.address?.city,
          state: res?.data?.success?.address?.state,
          zip: res?.data?.success?.address?.zip
        });
        setDocumentId(res?.data?.success?.logoImageId)
        if (res?.data?.success?.logoImageBase64 !== "") {
          setMainImage("data:image/*;base64," + res?.data?.success?.logoImageBase64)
        }
      })
      .catch((error) => { });
  }, [documentId]);

  const validateWebsite = (): boolean => {
    const trimmedWebsite = values.website.trim();

    if (trimmedWebsite === "") {
      setErrors((prevErrors) => ({ ...prevErrors, website: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        website: "Website is required",
      }));
      return true;
    }

    if (!websiteRegex.test(trimmedWebsite)) {
      setErrors((prevErrors) => ({ ...prevErrors, website: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        website: "Invalid website format (Must start with http:// or https://)",
      }));
      return true;
    }

    setErrors((prevErrors) => ({ ...prevErrors, website: false }));
    return false;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    switch (name) {
      case "email":
        setErrors({ ...errors, email: false });
        break;
      case "organizationName":
        setErrors({ ...errors, organizationName: false });
        break;
      case "website":
        setErrors({ ...errors, website: false });
        break;
      case "phoneNumber":
        setErrors({ ...errors, phoneNumber: false });
        break;
      case "streetAddress":
        setErrors({ ...errors, streetAddress: false });
        break;
      case "unitNumber":
        setErrors({ ...errors, unitNumber: false });
        break;
      case "city":
        setErrors({ ...errors, city: false });
        break;
      case "state":
        setErrors({ ...errors, state: false });
        break;
      case "zip":
        setErrors({ ...errors, billingZipCode: false });
        break;
      default:
        break;
    }
    setValues({ ...values, [name]: value });
  };

  const formDetails = {
    basicDetails: [
      {
        label: "Organization Name",
        placeholder: "Enter Organization Name",
        value: values.organizationName,
        name: "organizationName",
        type: FORM_CONTROLFIELD_TYPES.TEXT,
        blurFunction: () => validateName(values.organizationName, setErrors),
        errorMessages: errorMessages.organizationName,
        isError: errors.organizationName,
        linkWebsite: false,
        width: "100%",
        required: true,
        maxLength: 50
      },
      {
        label: "Phone Number",
        placeholder: "Enter Phone No.",
        value: values.phoneNumber,
        name: "phoneNumber",
        type: FORM_CONTROLFIELD_TYPES.MOBILE,
        blurFunction: () => validateNumber(values.phoneNumber, setErrors, setErrorMessages),
        errorMessages: errorMessages.phoneNumber,
        isError: errors.phoneNumber,
        linkWebsite: false,
        width: "204px",
        required: true,
        maxLength: 10
      },
      {
        label: "Email Address",
        placeholder: "Enter Email Address",
        value: values.email,
        name: "email",
        type: FORM_CONTROLFIELD_TYPES.EMAIL,
        blurFunction: () => validateEmail(values.email, setErrors, setErrorMessages),
        errorMessages: errorMessages.email,
        isError: errors.email,
        linkWebsite: false,
        width: "204px",
        required: true
      },
      {
        label: "Website link",
        placeholder: "Enter Website Link",
        value: values.website,
        name: "website",
        type: FORM_CONTROLFIELD_TYPES.TEXT,
        blurFunction: validateWebsite,
        errorMessages: errorMessages.website,
        isError: errors.website,
        linkWebsite: true,
        width: "100%",
        required: true,
        maxLength: 50
      }
    ],
    address: [
      {
        label: "Street Address",
        placeholder: "Enter Street Address",
        value: values.streetAddress,
        name: "streetAddress",
        type: FORM_CONTROLFIELD_TYPES.TEXT,
        blurFunction: () => validateName(values.streetAddress, setErrors),
        errorMessages: errorMessages.streetAddress,
        isError: errors.streetAddress,
        linkWebsite: false,
        width: "100%",
        required: true
      },
      {
        label: "City",
        placeholder: "Enter City",
        value: values.city,
        name: "city",
        type: FORM_CONTROLFIELD_TYPES.TEXT,
        blurFunction: () => { },
        errorMessages: errorMessages.city,
        isError: errors.city,
        linkWebsite: false,
        width: "147px",
        required: true
      },
      {
        label: "State",
        placeholder: "Enter State",
        value: values.state,
        name: "state",
        type: FORM_CONTROLFIELD_TYPES.TEXT,
        blurFunction: () => { },
        errorMessages: errorMessages.state,
        isError: errors.state,
        linkWebsite: false,
        width: "120px",
        required: true
      },
      {
        label: "Zip",
        placeholder: "Enter Zip",
        value: values.zip,
        name: "zip",
        type: FORM_CONTROLFIELD_TYPES.TELEPHONE,
        blurFunction: () => validateZipCode(values.zip, setErrors, setErrorMessages),
        errorMessages: errorMessages.billingZipCode,
        isError: errors.billingZipCode,
        linkWebsite: false,
        width: "105px",
        maxLength: 5,
        required: true
      }
    ]
  }

  const checkEmptyFields = (): boolean => {
    let hasErrors = false;
    clearErrors();
    if (values.email.trim() === "") {
      setErrors((prevErrors) => ({ ...prevErrors, email: true }));
      hasErrors = true;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, email: false }));
    }

    if (values.phoneNumber.trim() === "") {
      setErrors((prevErrors) => ({ ...prevErrors, phoneNumber: true }));
      hasErrors = true;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, phoneNumber: false }));
    }

    if (values.website.trim() === "") {
      setErrors((prevErrors) => ({ ...prevErrors, website: true }));
      hasErrors = true;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, website: false }));
    }


    if (values.streetAddress?.trim() === "" || values.streetAddress?.trim() === undefined) {
      setErrors(({ ...errors, streetAddress: true }));
      hasErrors = true;
    } else {
      setErrors(({ ...errors, streetAddress: false }));
    }
    if (values.state?.trim() === "" || values.state?.trim() === undefined) {
      setErrors((prevErrors) => ({ ...prevErrors, state: true }));
      hasErrors = true;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, state: false }));
    }

    if (values.city?.trim() === "" || values.city?.trim() === undefined) {
      setErrors((prevErrors) => ({ ...prevErrors, city: true }));
      hasErrors = true;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, city: false }));
    }

    if (values.zip?.trim() === "" || values.zip?.trim() === undefined) {
      setErrors((prevErrors) => ({ ...prevErrors, billingZipCode: true }));
      hasErrors = true;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, billingZipCode: false }));
    }

    if (values.organizationName.trim() === "") {
      setErrors({ ...errors, organizationName: true });
      setErrorMessages({ ...errorMessages, organizationName: "Organization Name is required" });
      hasErrors = true;
    }
    return hasErrors;
  };

  const submitTimeError = () => {
    return (
      errors.organizationName || errors.email ||
      errors.phoneNumber || errors.streetAddress || errors.website || errors.unitNumber ||
      errors.city || errors.state || errors.billingZipCode ||
      values.organizationName.trim() === "" || values.streetAddress?.trim() === "" ||
      values.phoneNumber.trim() === "" || values.email.trim() === "" || values.website.trim() === "" ||
      values.state.trim() === "" || values.zip.trim() === ""
    );
  };

  const uploadImage = (doc) => {
    const docData = {
      EntityTypeId: doc.EntityTypeId,
      EntityId: doc.EntityId,
      DocumentTypeId: doc.DocumentTypeId,
      IsMain: doc.IsMain,
      FileName: doc.FileName,
      Document: doc.Document,
    };
    return apiHelper(DocumentService.postApiDocument, { showNotification: false }, docData).then((res) => {
      {
        setDocumentId(res?.data?.success?.id)
      }
    }).catch((error) => { console.error("Error uploading document:", JSON.stringify(error)); });
  };

  const handleAddDetails = (e) => {
    e.preventDefault();
    checkEmptyFields();
    if (submitTimeError()) {
    }
    else {
      if (mainImage instanceof Blob) {
        const imgData = {
          EntityTypeId: DocumentEntityTypesEnum.Organization,
          EntityId: sessionStorage.getItem(UserLoginData.organization_id),
          DocumentTypeId: DocumentTypesEnum.Logo,
          Document: mainImage,
          FileName: fileName,
        };
        uploadImage(imgData)

      }
      const newValues = {
        name: values.organizationName,
        logoImageId: documentId,
        //logoImageBase64: mainImage instanceof Blob ? URL.createObjectURL(mainImage) : mainImage,
        unitNumber: values.unitNumber,
        phoneNumber: values.phoneNumber,
        email: values.email,
        website: values.website,
        address: {
          streetAddress: values.streetAddress,
          city: values.city,
          state: values.state,
          zip: values.zip
        },
        id: Number(sessionStorage.getItem(UserLoginData.organization_id)),
      };
      apiHelper(OrganizationService.putApiOrganization,
        {
          successMessage: "Basic Details Updated Successfully",
          failureMessage: "Unable to Update Basic Details",
          showNotification: true,
        }, newValues
      ).then((res) => {
        if (res?.data?.success) {
          getUserData();

          setShowModal(false)
        } else if (res?.errors?.PhoneNumber) {
          setErrors((prevErrors) => ({ ...prevErrors, phoneNumber: true }));
          setErrorMessages((prevMessages) => ({ ...prevMessages, phoneNumber: res.errors.PhoneNumber[0] }));
        }
      }).catch((imageErr: any) => { });
    }
  };

  useEffect(() => {
    if (checkEmptyFields()) {
      clearErrors();
    }
  }, []);

  // useEffect(() => {
  //   if (propertyValue?.address) {
  //     setValues({
  //       ...values,
  //       streetAddress: propertyValue?.address?.streetAddress,
  //       city: propertyValue?.address?.city,
  //       state: propertyValue?.address?.state,
  //       zip: propertyValue?.address?.zip
  //     })
  //     setErrors(({ ...errors, streetAddress: false, state: false, city: false, billingZipCode: false }));
  //   }
  // }, [propertyValue])


  const ResetFields = () => {
    setData({});
    setValues({ organizationName: "", email: "", phoneNumber: "", website: "", streetAddress: "", unitNumber: "", city: "", state: "", zip: "" });
    getUserData();
    clearErrors();
    setShowModal(true);
  }

  const orgImage = data && data?.logoImageBase64 ? data?.logoImageBase64 : GetImages.HomeBlackFilled

  return (
    <>
      <div className='basic_detail_card'>
        <div className='org_detail_container'>
          <img src={orgImage} alt='' style={{ height: "68px", width: "68px" }} />
          <div>
            <h6 className='sub_heading black' style={{ lineHeight: "20px" }}>{data && data?.name}</h6>
            <p className='sub_text grey_subtext1 mb-2'>
              {data?.unitNumber ? `${data?.unitNumber},` : ''}
              {data?.address?.streetAddress}, {data?.address?.city}, {data?.address?.state}, {data?.address?.zip}
            </p>
            <div className="singleTenantNameDetailsLeftSide">
              <div className="singleTenantUnitOr">
                <span className="sub_text black ms-0 d-flex gap-1 align-items-center">
                  <img
                    height={16}
                    width={16}
                    src={GetImages.mailIconOrange}
                  />
                  <p className="grey_subtext1">{data?.email}</p>
                </span>
                <SeparaterLine height={"25px"} background={undefined} />
                <span className="sub_text black ms-0 d-flex gap-1 align-items-center">
                  <img
                    height={18}
                    width={18}
                    src={GetImages.phoneIconOrange}
                  />
                  <p>{data?.phoneNumber}</p>
                </span>
                {data?.website &&
                  <>
                    <SeparaterLine height={"25px"} background={undefined} />
                    <span className="sub_text black ms-0 d-flex gap-1 align-items-center">
                      <img
                        height={18}
                        width={18}
                        src={GetImages.orangeContractor}
                      />
                      <p>{data?.website}</p>
                    </span>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
        <div className='bluePencilEdit' onClick={() => ResetFields()}>
          <img src={GetImages.BluePencilEdit} alt='' />
        </div>
      </div>
      <Offcanvas
        className="editTanentOffcanvas"
        show={showModal}
        onHide={() => setShowModal(false)}
        placement={"end"}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Basic Details</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <BasicDetailsForm
            mainImage={mainImage}
            setMainImage={setMainImage}
            formDetails={formDetails}
            handleChange={handleChange}
            submitHandler={handleAddDetails}
            isUploader={true}
            setShowModal={setShowModal}
            propertyValue={propertyValue}
            setPropertyvalue={setPropertyvalue}
            values={values}
            setValues={setValues}
            documentId={documentId}
            setDocumentId={setDocumentId}
            setFileName={setFileName}
            fetchData={getUserData}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default BasicDetailsCard